<template>
    <Details/>
</template>
<script>
import detailsPrint from '../components/request/RequestDetailPrint.vue';

export default {
    components: {
        Details: detailsPrint
    }
};
</script>
